import React from 'react';
import { Box, Typography } from '@mui/material';

const RiskLegend: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      <Typography variant="caption" sx={{ fontWeight: 600 }}>Risk Legend:</Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Box sx={{ width: 12, height: 12, bgcolor: '#16a34a', borderRadius: '2px' }} />
        <Typography variant="caption">Low Risk (On-Time &lt; 39%)</Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Box sx={{ width: 12, height: 12, bgcolor: '#f59e0b', borderRadius: '2px' }} />
        <Typography variant="caption">Medium Risk (40%-59%)</Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Box sx={{ width: 12, height: 12, bgcolor: '#dc2626', borderRadius: '2px' }} />
        <Typography variant="caption">High Risk (&gt; 60%)</Typography>
      </Box>
    </Box>
  );
};

export default RiskLegend;
